import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import PdpEmail from '../PlantDetail/pdpEmail';
const NotifyButton = ({ djangoPk, plantName, showTitle = false }) => {
    const [overlay, setOverlay] = useState(false);
    const handleClick = (e) => {
        if (e) {
            e.preventDefault();
        }
        setOverlay((prev) => !prev);
    };
    const closeOverlay = () => {
        setOverlay(false);
    };
    return (React.createElement("div", { className: "notify_btn" },
        React.createElement("div", null,
            React.createElement("button", { type: "button", className: "btn primary inverted", onClick: handleClick }, "Notify me")),
        showTitle && (React.createElement("div", null,
            React.createElement("p", null, "Notify me when this item is available on Plant Lust."))),
        React.createElement(Modal, { onClose: () => {
            }, open: overlay },
            React.createElement(Box, { className: "options_modal notify_me" },
                React.createElement("button", { type: "button", onClick: () => {
                        setOverlay(false);
                    }, className: "close_btn" },
                    React.createElement(CloseIcon, null)),
                React.createElement(Box, { className: "options_modal_wrapper" },
                    React.createElement("div", { className: "pdp_email_modal" },
                        React.createElement("div", { className: "modal_item_container" },
                            React.createElement(PdpEmail, { plantId: djangoPk, plantName: plantName, closeModal: closeOverlay, isNotifyModal: true }))))))));
};
export default NotifyButton;
